import React, { useEffect, useCallback, useMemo } from "react";
import L from "leaflet";
import { useSelector } from "react-redux";
import { LayerGroup, GeoJSON } from "react-leaflet";
import { highlightedTreeMarker } from "../TreeDrawing/TreeDrawing";
import { highlightedEmissionMarker } from "../Emission/EmissionDrawing/EmissionDrawing";
import {
  highlightedWindTurbineMarker,
  highlightedExistingWindTurbineMarker,
} from "../WindTurbine/WindTurbineDrawing/WindTurbineDrawing";
import { highlightedMapPoiMarker } from "../MapPoi/MapPoiGeoJson/MapPoiGeoJson";
import { getSelectedPolygonColor } from "../../../utils/polygons/polygonColor";

const SelectedMapItemPolygon = ({ layerRef }) => {
  const selectedMapItemGeoJson = useSelector(
    (state) => state.map.selectedMapItemGeoJson
  );
  const inRasterSettingsMode = useSelector(
    (state) => state.map.inRasterSettingsMode
  );
  const currentObjectType = useSelector((state) => state.map.currentObjectType);

  const selectedTreeIndex = useSelector((state) => state.map.selectedTreeIndex);

  const getFeatureStyle = useCallback(
    (feature) => ({
      fillColor: getSelectedPolygonColor(feature.properties.t), // 🔥 Color updates when `t` changes
      weight: 2,
      opacity: 1,
      color: "black",
      fillOpacity: 1,
    }),
    []
  );

  const pointToLayer = useCallback((feature, latlng) => {
    switch (feature.properties.t) {
      case 6:
        return L.marker(latlng, { icon: highlightedTreeMarker });
      case 8:
        return L.marker(latlng, { icon: highlightedEmissionMarker });
      case 10:
        return L.marker(latlng, {
          icon:
            feature.properties.wtstate === 0
              ? highlightedWindTurbineMarker
              : highlightedExistingWindTurbineMarker,
          zIndexOffset: 11,
        });
      default:
        return L.marker(latlng, {
          icon: highlightedMapPoiMarker,
          zIndexOffset: 11,
        });
    }
  }, []);

  useEffect(() => {
    if (layerRef?.current?.leafletElement && selectedMapItemGeoJson) {
      layerRef.current.leafletElement
        .clearLayers()
        .addData(selectedMapItemGeoJson);
    }
  }, [currentObjectType, selectedMapItemGeoJson?.properties?.id]);

  if (
    inRasterSettingsMode ||
    !selectedMapItemGeoJson ||
    selectedTreeIndex !== null
  )
    return null;

  return (
    <LayerGroup zIndex={1000} interactive={false}>
      <GeoJSON
        ref={layerRef}
        style={getFeatureStyle}
        pointToLayer={pointToLayer}
      />
    </LayerGroup>
  );
};

export default React.memo(SelectedMapItemPolygon);
